'use client';

import { PageHeader } from '@/shared/layout';
import { FileText, CheckCircle2, Server, UserCog, CalendarCheck, CreditCard, AlertTriangle, Scale, type LucideIcon } from 'lucide-react';
import { usePageContent } from '@/core/i18n/content';
import { TERMS_CONTENT } from '@/core/i18n/content/terms.content';

const SECTION_ICONS: LucideIcon[] = [CheckCircle2, Server, UserCog, CalendarCheck, CreditCard, AlertTriangle, Scale, FileText];

export function TermsOfService() {
  const c = usePageContent(TERMS_CONTENT);

  return (
    <div id="legal-terms-root" className="min-h-screen bg-hms-bg">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <PageHeader title={c.title} description={c.description} />
        <p id="legal-terms-intro" className="mt-6 text-sm text-hms-textSub leading-relaxed">
          {c.intro}
        </p>
        <div id="legal-terms-sections" className="mt-8 space-y-6">
          {c.sections.map((section, idx) => {
            const Icon = SECTION_ICONS[idx] || FileText;
            return (
              <section key={idx} id={`legal-terms-section-${idx}`} className="rounded-xl border border-hms-border bg-hms-card p-6 space-y-3">
                <h2 className="text-base font-semibold text-hms-text flex items-center gap-2">
                  <Icon className="h-4 w-4 text-hms-gold" />
                  {section.title}
                </h2>
                <p className="text-sm text-hms-textSub leading-relaxed">{section.content}</p>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}
